import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Plano } from "../page/plano/plano";

@Injectable({
  providedIn: 'root'
})
export class PlanoService {

  apiURL: string = environment.apiBaseUrl + 'plano';

  constructor(private http: HttpClient) { }

  getById(id: number) {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }
  save(plano: Plano): Observable<Plano> {
    return this.http.post<Plano>(this.apiURL, plano);
  }

  list(page: number, size: number): Observable<any> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }
  update(plano: Plano): Observable<any> {
    return this.http.put<Plano>(`${this.apiURL}/${plano.id}`, plano);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }

  buscarPlanosAtivos(segmentoId?: number | null): Observable<Plano[]> {
    let params = new HttpParams();
    if (segmentoId != null) {
      params = params.set('segmentoId', segmentoId.toString());
    }
    return this.http.get<Plano[]>(`${this.apiURL}/ativos`, { params });
  }

  sincronizarWowve(id: number): Observable<Plano> {
    return this.http.post<Plano>(`${this.apiURL}/${id}/sincronizar-wowve`, {});
  }
}
